import { render } from "./ConstantDataTab.vue?vue&type=template&id=572a10d2"
import script from "./ConstantDataTab.vue?vue&type=script&lang=js"
export * from "./ConstantDataTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__